import AddCb from './AddCb';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const AddCbWrapper = () => {
  const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  return (
    <Elements stripe={stripe}>
      <AddCb />
    </Elements>
  );
};

export default AddCbWrapper;
